module.exports = __webpack_public_path__ + "img/gui_huzheng.bf185e2f.png";